<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";

export default {
	name: "compUmatkrisma",
	props: ["triggerValidation"],
	data() {
		return {
			myOptions: {
				kriteria: umatOpt.kriteria,
				paroki: umatData.paroki,
				keuskupan: umatData.keuskupan,
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatKrismaItem: (state) => state.umatKrisma.item,
		}),
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		triggerValidation: function (_newVal, _oldVal) {
			this.trigger();
		},
	},
	methods: {
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateStateCustom(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				if (this.veeErrors.has(ref)) {
					return { "is-invalid": true };
				} else {
					return { "is-valid": true };
				}
			}
			return null;
		},
		trigger() {
			this.$emit("validate", this.$validator.validateAll());
			this.$validator.validateAll();
		},
	},
};
</script>

<template>
	<div class="form theme-form">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>No Buku LC <span class="text-danger">*</span></label>
					<b-form-input
						name="no_buku_lc"
						v-model="umatKrismaItem.no_buku_lc"
						v-validate="{ required: true }"
						:state="validateState('no_buku_lc')"
						data-vv-as="No. Buku LC"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_buku_lc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>No LC <span class="text-danger">*</span></label>
					<b-form-input
						name="no_lc"
						v-model="umatKrismaItem.no_lc"
						v-validate="{ required: true }"
						:state="validateState('no_lc')"
						data-vv-as="No. LC"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_lc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tanggal Krisma <span class="text-danger">*</span></label>
					<b-form-input
						name="tgl_krisma"
						:state="validateState('tgl_krisma')"
						data-vv-as="Tanggal Krisma"
						v-validate="{ required: true }"
						v-model="umatKrismaItem.tgl_krisma"
						size="sm"
						type="date"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tgl_krisma")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Pemberi Krisma<span class="text-danger">*</span></label>
					<b-form-input
						name="pemberi_krisma"
						v-model="umatKrismaItem.pemberi_krisma"
						v-validate="{ required: true }"
						:state="validateState('pemberi_krisma')"
						data-vv-as="Pemberi Krisma"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("pemberi_krisma")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Wali I</label>
					<b-form-input
						name="wali1"
						v-model="umatKrismaItem.wali1"
						v-validate="{ required: false }"
						:state="validateState('wali1')"
						data-vv-as="Wali I"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("wali1")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Wali II</label>
					<b-form-input
						name="wali2"
						v-model="umatKrismaItem.wali2"
						v-validate="{ required: false }"
						:state="validateState('wali2')"
						data-vv-as="Wali II"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("wali2")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Keuskupan LC <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="keuskupan_lc"
						:class="validateStateCustom('keuskupan_lc')"
						data-vv-as="Keuskupan LC"
						v-validate="{ required: true }"
						v-model="umatKrismaItem.keuskupan_lc"
						:minMatchingChars="1"
						:data="myOptions.keuskupan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("keuskupan_lc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Paroki LC<span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="paroki_lc"
						:class="validateStateCustom('paroki_lc')"
						data-vv-as="Paroki LC"
						v-validate="{ required: true }"
						v-model="umatKrismaItem.paroki_lc"
						:minMatchingChars="1"
						:data="myOptions.paroki"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("paroki_lc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tempat <span class="text-danger">*</span></label>
					<b-form-input
						name="tempat"
						v-model="umatKrismaItem.tempat"
						v-validate="{ required: true }"
						:state="validateState('tempat')"
						data-vv-as="Tempat"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tempat")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
	</div>
</template>

